import * as React from 'react';
import Player from 'react-player';

export type Props = {
  id?: string,
  path: string,
  className?: string,
  thumb?: string,
  playing?: boolean,
};

const Video = ({
 className, path, thumb, playing, ...props
}: Props): JSX.Element => {
  const isYouTubeVideo = React.useMemo(() => {
    if (!path) return false;
    return path.includes('youtube.com')
      || path.includes('youtu.be')
      || path.includes('youtube-nocookie.com');
  }, [path]);

  // YouTube configuration to fix error 15/153
  // YouTube now requires an HTTP Referer header for embedded players
  // Only apply this config for YouTube videos, not for self-hosted videos
  const config = React.useMemo(() => {
    if (!isYouTubeVideo) return undefined;

    return {
      youtube: {
        embedOptions: {
          referrerPolicy: 'strict-origin-when-cross-origin',
        },
        playerVars: {
          origin: typeof window !== 'undefined' ? window.location.origin : undefined,
        },
      },
    };
  }, [isYouTubeVideo]);

  return (
    <div className="Video">
      <Player
        playing={!!thumb || playing}
        controls
        width="100%"
        height="100%"
        className={`Video__Player${className ? ` ${className}` : ''} tw-bg-contain`}
        url={path}
        light={thumb}
        config={config}
        {...props}
      />
    </div>
  );
};

export default Video;
